module.exports = __webpack_public_path__ + "static/rothenberg-hex-gray-e50fbbed90a5e830d79f23acf270ec23.png";